const droneList = [
    {
        file: './drones/01 Cello Drone C.mp3',
        name: 'C'
    },
    {
        file: './drones/02 Cello Drone G.mp3',
        name: 'G'
    },
    {
        file: './drones/03 Cello Drone D.mp3',
        name: 'D'
    },
    {
        file: './drones/04 Cello Drone A.mp3',
        name: 'A'
    },
    {
        file: './drones/05 Cello Drone E.mp3',
        name: 'E'
    },
    {
        file: './drones/06 Cello Drone B.mp3',
        name: 'B'
    },
    {
        file: './drones/07 Cello Drone Gb.mp3',
        name: 'Gb'
    },
    {
        file: './drones/08 Cello Drone Db.mp3',
        name: 'Db'
    },
    {
        file: './drones/09 Cello Drone Ab.mp3',
        name: 'Ab'
    },
    {
        file: './drones/10 Cello Drone Eb.mp3',
        name: 'Eb'
    },
    {
        file: './drones/11 Cello Drone Bb.mp3',
        name: 'Bb'
    },
    {
        file: './drones/12 Cello Drone F.mp3',
        name: 'F'
    }
]

export default droneList